'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconCirclePartialBroken, iconCirclePartialBrokenTag } from '@ni/nimble-components/dist/esm/icons/circle-partial-broken';
import { wrap } from '../../utilities/react-wrapper';

export type { IconCirclePartialBroken };
export { iconCirclePartialBrokenTag };
export const NimbleIconCirclePartialBroken = wrap(IconCirclePartialBroken);